import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "label", "spinner", "loadingLabel"]

  start() {
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = true
    }

    if (this.hasLabelTarget) {
      this.labelTarget.classList.add("d-none")
    }

    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove("d-none")
    }

    if (this.hasLoadingLabelTarget) {
      this.loadingLabelTarget.classList.remove("d-none")
    }
  }

  stop() {
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = false
    }

    if (this.hasLabelTarget) {
      this.labelTarget.classList.remove("d-none")
    }

    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add("d-none")
    }

    if (this.hasLoadingLabelTarget) {
      this.loadingLabelTarget.classList.add("d-none")
    }
  }
}
